import { mapRasse } from '@ps20-frontend/migrations';
import { Versicherungsnehmer } from '../reducers/versicherungsnehmer.reducer';
import { StatePreV6, StateV6 } from './6_migrate_rasse.interface';

export const migrateRasse = (previousState: StatePreV6, newVersion: number): StateV6 => {
  return {
    ...previousState,
    version: newVersion,
    versicherungsnehmer: {
      ...previousState.versicherungsnehmer,
      rasse: {
        ...previousState.versicherungsnehmer?.rasse,
        value: mapRasse(previousState.versicherungsnehmer.rasse?.value),
      },
    } as Versicherungsnehmer,
  };
};
